import { ErrorType } from "./errorType";

export type ErrorInfo = {
  title: string;
  description: string;
  action: string;
  label: string;
};

const getProviderName = (): string =>
  localStorage.getItem("providerName") || "";

export const getErrorInfo = (code?: string): ErrorInfo => {
  const providerName = getProviderName();

  switch (code) {
    case ErrorType.AnotherAccountGlobo:
      return {
        title: `Esse login ${providerName} já está associado à outra Conta Globo`,
        description:
          "Use a conta Globo vinculada a este login ou ative o benefício com outra conta da sua operadora.",
        action: "help-center-or-try-another-provider",
        label: `Erro Login ${providerName} ja Associado`
      };
    case ErrorType.ErrProviderWithoutResources:
      return {
        title: "Esse conteúdo não está incluso na assinatura de sua operadora",
        description:
          "Para acessar o conteúdo, tente outra operadora. Caso já tenha adquirido ele pela sua operadora atual, entre em contato com ela.",
        action: "try-again-another-provider",
        label: "Erro Conteudo Nao Incluso"
      };
    case ErrorType.UserWithoutPackage:
      return {
        title: "Esse canal não está incluso na assinatura de sua operadora ",
        description:
          "Você pode tentar outra operadora para acessar o conteúdo ou seguir com a associação e acessar os outros canais disponíveis pela sua assinatura.",
        action: "association-or-try-another-provider",
        label: "Erro Canal Nao Incluso"
      };
    case ErrorType.InvalidCredentials:
      return {
        title: "Usuário não autorizado",
        description:
          "O usuário ou senha informados estão incorretos. Por favor, tente novamente.",
        action: "authentication-error",
        label: "Usuario ou senha incorretos"
      };
    case ErrorType.ProviderGenericError:
      return {
        title: `Algo deu errado na comunicação com a operadora ${providerName}`,
        description: `Tivemos uma falha na comunicação com a ${providerName}. Por favor, tente novamente.`,
        action: "try-again",
        label: "Erro generico operadora"
      };
    case ErrorType.ProviderContentNotIncluded:
      return {
        title: "Fale com a sua operadora",
        description: `Não há assinaturas disponíveis para ativação. Fale com a sua operadora para saber mais sobre os detalhes do seu plano ${providerName}.`,
        action: "try-again-another-provider",
        label: "Erro Conteudo Nao Incluso Operadora"
      };
    default:
      return {
        title: "Algo deu errado",
        description:
          "Ocorreu um erro e não foi possível continuar. Tente novamente.",
        action: "try-again",
        label: "Erro Generico"
      };
  }
};

/** @deprecated use getErrorInfo — mantido para compatibilidade com imports existentes */
export const errors = {
  has: (_code?: string) => true,
  get: (code?: string) => getErrorInfo(code)
};
